module.exports = __webpack_public_path__ + "static/media/music.d340a929.png";